export const PICTURES = {
	OWNER_CARD_FRONT: 'Tarjeta de propiedad - Frontal',
	OWNER_CARD_BACK:'Tarjeta de propiedad - Posterior',
	FRONT: 'Foto frontal',
	BACK: 'Foto posterior',
	LEFT: 'Lateral del piloto',
	RIGHT: 'Lateral del copiloto',
	UP : 'Techo',
	TIRE: 'Llanta y aro',
	SPARE_TIRE: 'Llanta de repuesto',
	TRUNK: 'Maletera abierta',
	BOARD_ON: 'Tablero encendido',
	BOARD_RUDDER: 'Tablero y timón',
	RADIO_LEVER: 'Radio y palanca',
	MOTOR: 'Motor',
	CHASSIS_NUMBER: 'Número de chasis',
	TIRE_FRONT_RIGHT: 'Llanta delantera copiloto',
	TIRE_FRONT_LEFT: 'Llanta delantera piloto',
	TIRE_BACK_RIGHT: 'Llanta posterior copiloto',
	TIRE_BACK_LEFT: 'Llanta posterior piloto',
};

export const WITHOUT_SPARE_TIRE = {
	src: 'https://starkinteusa.blob.core.windows.net/static/motivos_llanta.png'
}

export const ACCESORIES = {
	RADIO: 'Radio',
	COMPONENTS: 'Componentes',
	AMPLIFIERS: 'Amplificadores',
	SPEAKERS:'Parlantes',
	EQUALIZERS: 'Ecualizadores',
	SUBWOOFER: 'Subwoofers',
}	

export const RIM_OR_WELLS = {
	WHEEL: 'Llantas',
	RIM: 'Aros'
}


export const DAMAGES_PICTURES = {
	FRONT: 'Zona delantera',
	BACK: 'Zona posterior',
	RIGHT: 'Lado del copiloto',
	LEFT: 'Lado del piloto',
	UP: 'Techo'
}



// WEBPACK FOOTER //
// ./src/constants/app/files.js